const spriteRender = (theme) => {
  fetch(`/wp-content/themes/${theme}/dist/img/sprite.svg?v=4`)
    .then((res) => (res.ok ? res.text() : null))
    .then((sprite) => sprite && (document.getElementById('website-sprite').innerHTML = sprite))
}

export default spriteRender
